"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyAisleCode = void 0;
exports.formatSpanishPhone = formatSpanishPhone;
exports.formatInternationalPhone = formatInternationalPhone;
const libphonenumber_js_1 = require("libphonenumber-js");
const modifyAisleCode = (aisleCode) => {
    const match = aisleCode.match(/0-A(\d+)/);
    if (match) {
        const originNumber = parseInt(match[1], 10);
        const newNumber = originNumber + 1;
        return newNumber.toString();
    }
    else {
        return 'Formato no válido';
    }
};
exports.modifyAisleCode = modifyAisleCode;
function formatSpanishPhone(phone) {
    let digits = phone.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('34')) {
        digits = digits.slice(2);
    }
    if (digits.length === 9) {
        return `+34 ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)}`;
    }
    return phone;
}
function formatInternationalPhone(phone) {
    if (!phone)
        return '';
    try {
        const phoneNumber = (0, libphonenumber_js_1.parsePhoneNumber)(phone);
        if (phoneNumber) {
            return phoneNumber.formatInternational();
            // Retornará: +34 600 49 38 00
        }
    }
    catch (error) {
        // Si el número es inválido, devolvemos el original o una limpieza básica
        return phone;
    }
    return phone;
}
